export default __webpack_public_path__ + "static/media/twoshoes.107d0314.jpg";